
import Vue from "vue";
import Component from "vue-class-component";
import ReceberService from "@/service/receber.service"
import {ReceberFilter} from '@/models/cliente/receber-filter.interface';
import HeaderModel from '@/models/headers.model';
import Listas from "@/models/lists/listas.model";
import DescricaoID from "@/models/lists/descricao-id.model";
import EnderecoService from "@/service/endereco.service";
import DatePickerComponent from "@/components/DatePickerComponent.vue";
import ReceberResponse from "@/models/receber-response";
import {namespace} from 'vuex-class';
import {MapActionsSnackbar} from "@/store/modules/snackbar/map-actions.snackbar";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";

const snackbar = namespace('snackbar');
const loading = namespace('loading');

@Component({
  name: "Receber",
  components: {DatePickerComponent}
})
export default class Receber extends Vue {

  @snackbar.Action(MapActionsSnackbar.SET_SNACKBAR_ERROR) setSnackbarError;
  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private iconDinamic = false;
  private panel = [];
  private allHeaders: Array<HeaderModel> = [];
  private headersGrid: Array<HeaderModel> = [];
  private receberResponse = new ReceberResponse();
  private headersSelecionados: Array<any> = [];
  private filtro = {} as ReceberFilter;
  private listas = new Listas();
  private estados: Array<DescricaoID> = [];

  async localizar() {
    if (this.validaRange()) {
      this.openLoading();
      this.receberResponse.itens = [];
      this.receberResponse = await ReceberService.localizar(this.filtro);
      this.panel = [];
      this.closeLoading();
    }
  }

  limpar() {
    this.filtro = {} as ReceberFilter;
  }

  setHeadersSelecionado() {
    this.headersGrid = [];
    this.allHeaders.forEach(h => {
      this.headersSelecionados.forEach(hs => {
        if (hs === h.id) {
          this.headersGrid.push(h);
        }
      })
    });
    if (this.headersGrid.length === 0) {
      this.headersGrid = this.listas.headersReceberDefault;
    }
  }

  async mounted() {
    this.openLoading();
    this.allHeaders = this.listas.headersReceberAll;
    this.headersGrid = this.listas.headersReceberDefault;
    this.headersSelecionados = this.listas.headersReceberDefault;
    this.estados = await EnderecoService.getEstados();
    this.receberResponse = await ReceberService.localizar(undefined);
    this.closeLoading();
  }

  validaRange() {
    if (this.filtro.data_filtro) {
      if (this.filtro.data_inicio && this.filtro.data_fim) {
        return true;
      } else {
        this.setSnackbarError('É obrigatório informar a data de início e de fim!');
        return false;
      }
    }
    return true;
  }

  goToDownUp() {
    const element = document.getElementById("box");
    if (element) {
      if (this.iconDinamic) {
        element.scrollIntoView({block: "start"});
        this.iconDinamic = false;
      } else {
        element.scrollIntoView({block: "end"});
        this.iconDinamic = true;
      }
    }
  }

}
